import { gql } from '@apollo/client';
import operationResultFragment from '../../../shared/queries/operationResultFragment';

const ACTIVATE_LICENSE = gql`
  mutation ActivateUserLicense($externalUserId: Int!) {
    activateUserLicense(externalUserId: $externalUserId) {
      ...OperationResultFields
    }
  }
  ${operationResultFragment}
`;

export default ACTIVATE_LICENSE;
